import { Alert, AlertDescription, AlertTitle } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
import {
  STRUCTURED_FORMAT_CATEGORIES,
  STRUCTURED_FORMAT_EXAMPLE,
} from './GuidelineFormSheet.types';

export interface GuidelineImportFormatHintProps {
  error: string | null;
}

export function GuidelineImportFormatHint({ error }: GuidelineImportFormatHintProps) {
  const { t } = useTranslation('knowledge');

  return (
    <div className="flex flex-col gap-xs">
      {error && (
        <Alert variant="destructive">
          <AlertTitle>
            {t('guidelines.useImportGuidelinesFromFiles.failedToImportGuidelines')}
          </AlertTitle>
          {/* AlertDescription's own muted colour outranks a text class on it, so the child carries it. */}
          <AlertDescription>
            <span className="text-destructive">{error}</span>
          </AlertDescription>
        </Alert>
      )}
      <Alert>
        <AlertTitle>{t('guidelines.guidelineFormSheet.textFileFormat')}</AlertTitle>
        <AlertDescription className="flex flex-col gap-xs">
          <span>{t('guidelines.guidelineFormSheet.textFileFormatDescription')}</span>
          <pre className="overflow-x-auto rounded-sm bg-muted p-xs text-xs whitespace-pre-wrap text-foreground">
            {STRUCTURED_FORMAT_EXAMPLE}
          </pre>
          <span>
            {t('guidelines.guidelineFormSheet.validCategories', {
              categories: STRUCTURED_FORMAT_CATEGORIES,
            })}
          </span>
        </AlertDescription>
      </Alert>
    </div>
  );
}

GuidelineImportFormatHint.displayName = 'GuidelineImportFormatHint';
